import { Box, FormControl, Grid, Popover, Typography, withStyles } from '../../../../shared/components/MaterialUIComponents';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './questionnaire.style';
import { CustomIcons, icons } from '../../../../shared/components/custom-icons/CustomIcons';
import { useQuestionnaireHook } from './useQuestionnaireHook';

const Questionnaire = ({ classes, questions, title, startIndex }) => {
  const {
    anchorEl,
    popoverText,
    openPopover,
    handlePopoverOpen,
    handlePopoverClose,
    getAnswerText,
  } = useQuestionnaireHook();

  return (
    <Box className={classes.root}>
      <Box className={classes.content} data-testid="questionnaire-content">
        <Typography data-testid="questionnaire-title" color="primary" className={classes.title}>
          {title}
        </Typography>

        <Popover
          id="questionnaire-helper-text-popover"
          classes={{ paper: classes.popoverPaper }}
          open={openPopover}
          anchorEl={anchorEl}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          onClose={handlePopoverClose}
          disableRestoreFocus
          data-testid="popover"
        >
          <Typography data-testid="popover-text">{popoverText}</Typography>
        </Popover>

        <Grid container spacing={2} className={classes.gutterTop}>
          {questions.map((question, index) => (
            <Grid item xs={6} md={6} lg={6} key={question.id}>
              <FormControl fullWidth variant="outlined" className={classes.gutterTop}>
                <Box display="flex" alignItems="center">
                  <Typography
                    variant="h6"
                    data-testid={`question-${index}`}
                    className={classes.questionTitle}
                  >
                    {`${startIndex + index}. ${question.question}`}
                  </Typography>
                  {question.helpText && (
                    <CustomIcons
                      icon={icons.InfoOutlined}
                      className={classes.infoIcon}
                      aria-haspopup="true"
                      id={`demographic-help-icon-${index}`}
                      onClick={(e) => handlePopoverOpen(e, question.helpText)}
                    />
                  )}
                </Box>
                <Typography variant="h6" gutterBottom className={classes.disabled}>
                  {getAnswerText(question.answer, question.answerOptions)}
                </Typography>
              </FormControl>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

Questionnaire.propTypes = {
  classes: PropTypes.object.isRequired,
  questions: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  startIndex: PropTypes.number.isRequired,
};

export default withStyles(styles)(Questionnaire);
